import React, { useEffect, useState } from 'react';

import { Button, Paper } from '@mui/material';

import classes from './PaymentResult.module.scss';
import { ResultTitle } from '../../../../components/payment-result/ResultTitle/ResultTitle';
import { PaymentDetails } from '../../../../components/payment-result/PaymentDetails/PaymentDetails';
import { PaymentInfo } from '../../../../interfaces/paymentResult';
import { stripeService } from '../../../../services/stripeService';
import { goTo } from '../../../../../shared/utils/angularUtils';
import { ENTITY_PROFILE_TAB_NAME } from '../../../../../shared/constants/tabNames/ENTITY_PROFILE_TAB_NAME';
import { pathQueryParams } from '../../../../../shared/constants/pathQueryParams';

type PaymentResultProps = {
  entityId: number;
  paymentIntentId: string;
};

const PaymentResult = ({ entityId, paymentIntentId }: PaymentResultProps) => {
  const [paymentInfo, setPaymentInfo] = useState<PaymentInfo | null>(null);

  const getPaymentInfo = async () => {
    const info = await stripeService.getSelfBillingPaymentResult(
      entityId,
      paymentIntentId,
    );
    setPaymentInfo(info);
  };

  useEffect(() => {
    getPaymentInfo();
  }, []);

  if (!paymentInfo) {
    return null;
  }

  return (
    <Paper variant="roundedBox" className={classes.box}>
      <ResultTitle isSuccessful title="Thank you for your payment!" />
      <PaymentDetails paymentInfo={paymentInfo} />
      <Button
        variant="contained"
        size="medium"
        onClick={() => {
          goTo('/entity-profile', {
            replaceHistory: true,
            params: {
              [pathQueryParams.initialTabName]: ENTITY_PROFILE_TAB_NAME.PAYMENT,
            },
          });
        }}
      >
        Go to Profile
      </Button>
    </Paper>
  );
};

export { PaymentResult };
